// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3fsnL","content":"styles_content__q1g_4","flexButton":"styles_flexButton__gkKyA"};